import { v4 as uuidv4 } from 'uuid';

export function getRequestID(): string {
  return uuidv4();
}
